import { Clock, Edit2, TickCircle, Trash } from "iconsax-react";
import Paginator from "../Paginator";

const LEGuestListTable = ({
  data,
  meta,
  searchTerm,
  setSearchTerm,
  handleEditClick,
  handlePageClick,
  handleDeleteClick,
}) => {
  return (
    <div className="flex flex-col border border-[#EFF0F2] w-full h-fit bg-white rounded-xl">
      {/* Table data */}
      <div className="flex w-full h-full gap-[24px] overflow-x-auto">
        {!data || data.length === 0 ? (
          <div className="flex w-full h-[290px] items-center border-[#EFF0F2] justify-center text-gray-500 text-[25px]">
            No guests found
          </div>
        ) : (
          <div className="w-full overflow-x-auto">
            <table className="w-full min-w-max table-auto">
              {/* Table Header */}
              <thead>
                <tr className="w-full bg-[#F7F8F9] border-b border-[#EFF0F2]">
                  <th className="cursor-pointer text-start px-[24px] py-[16px] flex items-center gap-[12px] text-nowrap">
                    First Name
                  </th>
                  <th className="text-start px-[24px] py-[16px] text-nowrap">
                    Last Name
                  </th>
                  <th className="text-start px-[24px] py-[16px] text-nowrap">
                    Check-In Status
                  </th>
                  <th className="text-start px-[24px] py-[16px] text-nowrap">
                    Email
                  </th>
                  <th className="text-start px-[24px] py-[16px] text-nowrap">
                    Contact
                  </th>
                  <th className="text-start px-[24px] py-[16px] text-nowrap">
                    Table
                  </th>
                  <th className="text-start px-[24px] py-[16px] text-nowrap"></th>
                </tr>
              </thead>

              {/* Table Body */}
              <tbody>
                {data &&
                  data.map((item, index) => (
                    <tr
                      key={item.id}
                      className="w-full font-normal border-b last:border-none border-[#EFF0F2]"
                    >
                      <td className="px-[24px] py-[16px]">
                        {item.first_name ?? "-"}
                      </td>
                      <td className="px-[24px] py-[16px]">
                        {item.last_name ?? "-"}
                      </td>
                      <td className="px-[24px] py-[16px]">
                        {item.status === true ? (
                          <div className="flex w-fit rounded-md px-[8px] gap-[4px] items-center bg-[#F4FCF7] border border-[#E9F9EF] text-[#22C55E]">
                            <TickCircle size="16" variant="Bold" />
                            Checked
                          </div>
                        ) : (
                          <div className="flex w-fit rounded-md px-[8px] gap-[4px] items-center bg-[#FFFBF3] border border-[#FEF6E6] text-[#F0A009]">
                            <Clock size="16" variant="Bold" />
                            Pending
                          </div>
                        )}
                      </td>
                      <td className="px-[24px] py-[16px]">
                        {item.email ?? "-"}
                      </td>
                      <td className="px-[24px] py-[16px]">
                        {item.contact ?? "-"}
                      </td>
                      <td className="px-[24px] py-[16px]">
                        {item.le_table ?? "-"}
                      </td>
                      <td className="flex px-[24px] py-[16px] gap-2 justify-end">
                        <span
                          className="flex text-[#5C4BF5] text-[14px] items-center hover:underline cursor-pointer"
                          onClick={() => handleEditClick(item.id)}
                        >
                          <Edit2 size="15" variant="Bold" />
                          Edit
                        </span>
                        <span
                          className="flex text-[#EF4444] text-[14px] items-center hover:underline cursor-pointer"
                          onClick={() => handleDeleteClick(item.id)}
                        >
                          <Trash size="15" variant="Bold" />
                          Delete
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Pagination */}
      {meta && (
        <Paginator
          meta={meta}
          handlePageClick={handlePageClick}
          // perPage={perPage}
          // handlePerPageChange={handlePerPageChange}
        />
      )}
    </div>
  );
};

export default LEGuestListTable;
